//
//
//
//
//
//
//

import NavBar from '@/components/NavBar.vue';
import VideoWrapper from '@/components/VideoWrapper.vue';
export default {
    components: { NavBar, VideoWrapper }
};
